<template>
  <div class="skill">
    <figure>
      <h3 class="skill__title">
        <font-awesome-icon :icon="['fas', $props.icon]" class="skill__icon" />
        {{$props.title}}
      </h3>
      <div class="skill__list">
        <p v-for="skill in skills" :key="skill">{{skill}}</p>
      </div>
    </figure>
  </div>
</template>

<script>
export default {
  name: "Skill",
  props: ["icon", "title", "skills"]
};
</script>